"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redisHashItem_runtimeProgress_logEntryKey = exports.redisHashItem_runtimeProgress_taskOutputKey = exports.redisHashItem_runtimeProgress_taskStarting = exports.runtimeProgressSync_varSegment = exports.RuntimeProgressSync_primarySegmentPrefix = exports.RuntimeProgressSync_dataType = void 0;
const interfaces_1 = require("../interfaces");
/**
 * Various types of runtime data that can be persisted and broadcasts over websockets while authoring project instance runs.
 * Note: deleted when its kahbaRuntimeInstance is cleaned up.
 */
exports.RuntimeProgressSync_dataType = {
    /**
     * Holds/reports request data and output of each task
     */
    taskCycle: 'taskCycle',
    /**
     * Holds/reports log entries, which can be submitted from both tasks running in task-runner or externally invoked functions.
     * Uses timestamp-based item keys.
     */
    logEntry: 'logEntry',
    /**
     * Holds/reports arbitrary author data. Can be used for showing progress, especially when authoring project is relatively slow.
     */
    userInfo: 'userInfo',
};
exports.RuntimeProgressSync_primarySegmentPrefix = 'runtime_progress';
function runtimeProgressSync_varSegment() {
    return [
        // removing WiredIdentifier_TimestampMs from list--will track and clean up along with other kahbaRuntime data,
        interfaces_1.WiredIdentifier_KahbaRuntimeUid,
        interfaces_1.WiredIdentifier_RuntimeProgressType,
    ].map(segment => `/${segment}/:${segment}`).join('');
}
exports.runtimeProgressSync_varSegment = runtimeProgressSync_varSegment;
function redisHashItem_runtimeProgress_taskStarting(taskRuntimeUid) {
    return `taskStarting_${taskRuntimeUid}`;
}
exports.redisHashItem_runtimeProgress_taskStarting = redisHashItem_runtimeProgress_taskStarting;
function redisHashItem_runtimeProgress_taskOutputKey(taskRuntimeUid) {
    return `taskOutput_${taskRuntimeUid}`;
}
exports.redisHashItem_runtimeProgress_taskOutputKey = redisHashItem_runtimeProgress_taskOutputKey;
function redisHashItem_runtimeProgress_logEntryKey() {
    // Want it to start with a normal timestamp, then something random to make it resistant to collisions from parallel tasks adding
    //  entries in the same epochMs.
    // note: not using process.hrtime.bigint() because it doesn't output a date, isn't available in browser, and parallel tasks on different servers still might produce collisions
    // note: hopefully Math.random's seed isn't based on epochMs alone.. if so, switch to using crytpo random (and move this to shared-utils-iso)
    return `${Date.now()}.${Math.random().toString(36).slice(2)}`;
}
exports.redisHashItem_runtimeProgress_logEntryKey = redisHashItem_runtimeProgress_logEntryKey;
//# sourceMappingURL=runtime-progress-data.js.map